import styled from 'styled-components';
import * as UI from 'components/modules/UI/ui';

export const marginAlignMap = {
  left: {
    marginLeft: '15.5%',
    marginRight: 'auto',
    flex: 'flex-start',
  },
  right: {
    marginRight: '15.5%',
    marginLeft: 'auto',
    flex: 'flex-end',
  },
  center: {
    marginRight: 'auto',
    marginLeft: 'auto',
    flex: 'center',
  },
};

export const Section = styled(UI.Section)`
  position: relative;

  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-image: none;

  @media (min-width: 1280px) {
    display: flex;
    justify-content: ${({ textHorizAlign }) =>
    marginAlignMap[textHorizAlign].flex};
    background-image: ${({ backgroundImg }) => `url(${backgroundImg})`};
  }
`;

export const BackgroundImageOverlay = styled.div`
  @media (max-width: 1279px) {
    position: relative;
    width: 100%;
    height: 100vw;
  }
  height: auto;
  width: auto;

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-image: ${({ backgroundImageMobile }) =>
    `url(${backgroundImageMobile.src})`};
  opacity: ${({ backgroundImageMobile }) =>
    backgroundImageMobile.backgroundOpacity};
  @media (min-width: 1280px) {
    background-image: ${({ backgroundImageDesktop }) =>
    `url(${backgroundImageDesktop.src})`};
    opacity: ${({ backgroundImageDesktop }) =>
    backgroundImageDesktop.backgroundOpacity};
  }
`;

export const TextWrapper = styled.div`
  position: relative;

  display: flex;
  flex-shrink: 0;
  align-items: flex-start;
  flex-direction: column;

  transition: transform 0.2s ease;
  width: 100%;
  overflow: hidden;
  background-color: ${({ mobileBackgroundColor }) => mobileBackgroundColor};

  @media (min-width: 1280px) {
    height: auto;
    width: 50%;
    flex-direction: column;

    justify-content: ${({ textAlign }) => textAlign};
    background-color: ${({ backgroundColor }) => backgroundColor};
  }
`;

export const TextContainer = styled(UI.HalfContainer)`
  @media (min-width: 1280px) {
    text-align: ${({ textHorizAlign }) => textHorizAlign};
    margin-left: ${({ textHorizAlign }) =>
    marginAlignMap[textHorizAlign] &&
      marginAlignMap[textHorizAlign].marginLeft};
    margin-right: ${({ textHorizAlign }) =>
    marginAlignMap[textHorizAlign] &&
      marginAlignMap[textHorizAlign].marginRight};
  }
`;

export const Img = styled.img`
  display: block;
  width: 100%;
  height: 100%;

  object-fit: cover;
  object-position: 50% 50%;
`;

export const MobileBackgroundWrapper = styled.div`
  width: 100%;
  height: auto;
  @media (min-width: 1280px) {
    display: none;
  }
`;

export const MobileBackground = styled.div`
  display: block;
  width: 100%;
  height: 100%;

  object-fit: cover;
  object-position: center;
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;



// WEBPACK FOOTER //
// ./src/components/modules/TextImageSection/styled.js